// extracted by mini-css-extract-plugin
export default {"DFNumericTextBoxWrap":"iieFfyKLH0DXkgcK5XxA"};